import styled from "styled-components";
import { Row, Col } from "antd";
import { Slider } from "antd";
import { useEffect, useState } from "react";
import { LoadingPage } from "components/Common/LoadingPage/LoadingPage";
import BlindStateOn from "assets/pages/Dashboard/DeviceControl/BlindStateOn.svg";
import BlindStateOff from "assets/pages/Dashboard/DeviceControl/BlindStateOff.svg";

const Container = styled.div`
  width: 750px;
  height: 350px;
`;

const WrapCurtain = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 130px;
  padding: 0px 80px;
`;

const WrapSlider = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const SwitchButton = styled.div<any>`
  width: 150px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(1px 3px 20px rgba(57, 124, 221, 0.3));
  backdrop-filter: blur(20px);
  margin: 0px 40px 0px 40px;
  background: linear-gradient(154.82deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.3) 100%);
  box-shadow: 0px 3px 20px rgba(161, 183, 205, 0.2);
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 3px 20px rgba(161, 183, 205, 0.4);
  }
`;

const Image = styled.img`
  width: 56px;
  height: 56px;
`;

const marks = {
  0: "0%",
  100: {
    style: {
      color: "#788796",
    },
    label: <strong>100%</strong>,
  },
};

export const BlindControl = ({ command, handleChangeCommand, deviceData, agentId }: any) => {
  const [value, setValue] = useState<number | undefined | null>();
  const [initialValue, setInitialValue] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const onChangeBlind = (percent: number) => {
    setValue(percent);
    setIsLoading(true);
    if (percent === 0) {
      handleChangeCommand("control_state", "open", agentId, 0);
    } else if (percent === 100) {
      handleChangeCommand("control_state", "close", agentId, 0);
    } else {
      handleChangeCommand("percent_position", percent, agentId, 0);
    }
  };

  const onOpenClose = (percent: number) => {
    setValue(percent);
    if (percent === 0) {
      handleChangeCommand("control_state", "open", agentId, 0);
    } else if (percent === 100) {
      handleChangeCommand("control_state", "close", agentId, 0);
    }
  };

  const onChange = (sliderPercent: number) => {
    setValue(sliderPercent);
  };

  useEffect(() => {
    const percent = command?.percent_position;
    if (!percent) {
      setInitialValue(() => percent);
    } else {
      if (percent !== initialValue) {
        setIsLoading(false);
        setInitialValue(() => percent);
      }
    }
    setValue(() => Number(percent));
    return () => {
      setValue(undefined);
    };
  }, []);

  return (
    <Container>
      <Row>
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <>
                <WrapCurtain>
                  <SwitchButton onClick={() => onOpenClose(0)}>
                    <Image src={BlindStateOn} />
                  </SwitchButton>
                  <WrapSlider>
                    <Slider
                      marks={marks}
                      value={value ? value : 0}
                      tooltipVisible={true}
                      onChange={onChange}
                      onAfterChange={(percent: number) => onChangeBlind(percent)}
                    />
                  </WrapSlider>
                  <SwitchButton onClick={() => onOpenClose(100)}>
                    <Image src={BlindStateOff} />
                  </SwitchButton>
                </WrapCurtain>

                <p style={{ textAlign: "center", fontWeight: "bold" }}>
                  {value} %
                </p>
              </>
              {value === undefined && <p>No matching data found</p>}
              {value === null && <LoadingPage />}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
